import { moduleNames } from 'pages/Stores/components/modules';
import { createLooksConfig } from './LooksConfig';

const defaultValues = { selectedItems: [] };

export const createLooksModule = (useAvailableItems) => ({
  moduleName: moduleNames.MULTIPLE_LOOK,
  nameTranslationPath: 'Looks.title',
  descriptionTranslationPath: 'Looks.moduleDescription',
  iconClassName: 'bi bi-images',
  defaultValues,
  isValid: (values) => values.selectedItems?.length > 0,
  buildPayload: (values) => values.selectedItems.map((item) => item.uid),
  parseApiData: (module) => ({
    selectedItems: module.looks || (module.look ? [module.look] : []),
  }),
  ConfigComponent: createLooksConfig(useAvailableItems),
});
